type ThemeMode = 'light' | 'dark';

export const getThemeClasses = (mode: ThemeMode) => ({
  // Backgrounds - using CSS custom properties for consistency
  bg: {
    primary: mode === 'light' ? 'bg-[#FAF7F2]' : 'bg-gray-950',
    secondary: 'bg-secondary-bg',
    card: 'bg-card-bg',
    input: 'bg-card-bg',
    dialog: 'bg-card-bg',
    overlay: mode === 'light' ? 'bg-black/35' : 'bg-black/50',
  },
  
  // Text colors - using CSS custom properties
  text: {
    primary: 'text-text-primary',
    secondary: 'text-text-secondary',
    tertiary: 'text-text-tertiary',
    heading: 'text-text-primary',
  },
  
  // Borders - using CSS custom properties
  border: {
    primary: 'border-card-border',
    secondary: 'border-card-border',
    input: 'border-card-border',
  },
  
  // Dividers
  divider: 'border-card-border',
  
  // Hover states
  hover: {
    bg: 'hover:bg-hover-bg',
  },
  
  // Helper to get all background classes as a string
  bgClasses: {
    page: mode === 'light' ? 'bg-[#FAF7F2]' : 'bg-gray-950',
    card: 'bg-card-bg',
    section: 'bg-secondary-bg',
  },
  
  // Helper to get all text classes as a string
  textClasses: {
    body: 'text-text-primary',
    muted: 'text-text-secondary',
  },
});
